import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useOrg } from '../context/OrgContext';

/**
 * FeatureRoute — gating genérico de rutas por feature de organización.
 *
 * Regla (misma que el middleware backend requireFeature y el filtro del sidebar):
 *   Renderiza si el usuario es admin de people1 (role='admin') — que accede SIEMPRE a
 *   todo — O la org actual tiene el slug en `currentOrg.features`. Si no, redirige.
 *
 * Debe montarse dentro de PrivateRoute + OnboardingGuard (que ya resuelven auth/perfil)
 * y de OrgProvider. Contexto:
 * docs/plans/dev_miguel/2026-07-07_IPRESAS_GATING_ACCESO_FEATURES.md
 *
 * @param {string} feature       slug de la feature, p.ej. 'presas'
 * @param {string} [redirectTo]  destino si no hay acceso (default '/')
 */
const FeatureRoute = ({ feature, children, redirectTo = '/' }) => {
  const { userProfile } = useAuth();
  const { currentOrg, isLoading } = useOrg();

  // Esperar a que la org cargue para no parpadear un redirect erróneo.
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const isFlockAdmin = userProfile?.role === 'admin';
  const orgHasFeature =
    Array.isArray(currentOrg?.features) && currentOrg.features.includes(feature);

  if (!isFlockAdmin && !orgHasFeature) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default FeatureRoute;
